import { IGeracaoCredito } from "../interfaces/IGeracaoCredito";
import api from "./Api";

class GeracaoCreditoService {
    async obterTodos() :Promise<IGeracaoCredito[]> {
        try {
            const { data: result } = await api.get<IGeracaoCredito[]>('GeracaoCredito');
            
            return result;
        } catch (error) {	
            return [];
        }
    }
}

export default new GeracaoCreditoService();